import * as React from "react";
import { ITableItem } from "./TableData";
import { ObservableArray, ObservableValue } from "azure-devops-ui/Core/Observable";
import { Card } from "azure-devops-ui/Card";
import { renderSimpleCell, Table, TableColumnLayout } from "azure-devops-ui/Table";

export default class TableShimmerExample extends React.Component {
    private itemProvider = new ObservableArray<
        ITableItem | ObservableValue<ITableItem | undefined>
    >(new Array(5).fill(new ObservableValue<ITableItem | undefined>(undefined)));

    private asyncColumns = [
        {
            columnLayout: TableColumnLayout.singleLinePrefix,
            id: "name",
            name: "Name",
            readonly: true,
            renderCell: renderSimpleCell,
            width: -30,
        },
        { id: "age", name: "Age", readonly: true, renderCell: renderSimpleCell, width: -20 },
        {
            columnLayout: TableColumnLayout.none,
            id: "gender",
            name: "Gender",
            readonly: true,
            renderCell: renderSimpleCell,
            width: -50,
        },
    ];

    public render(): JSX.Element {
        return (
            <Card className="flex-grow bolt-table-card" contentProps={{ contentPadding: false }}>
                <Table<ITableItem>
                    ariaLabel="Table shimmer"
                    className="table-example"
                    columns={this.asyncColumns}
                    containerClassName="h-scroll-auto"
                    itemProvider={this.itemProvider}
                    role="table"
                />
            </Card>
        );
    }
}
